webpackJsonp([182730967086872],{

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(10);
	
	__webpack_require__(1095);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgettoPage = function (_Component) {
	  _inherits(ProgettoPage, _Component);
	
	  function ProgettoPage() {
	    _classCallCheck(this, ProgettoPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProgettoPage.prototype.render = function render() {
	    var _props$data$datoCmsPa = this.props.data.datoCmsPaginaProgetto,
	        testoInEvidenza = _props$data$datoCmsPa.testoInEvidenza,
	        testo = _props$data$datoCmsPa.testo,
	        sottotitolo = _props$data$datoCmsPa.sottotitolo;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'wrap-narrower' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Progetto | ',
	          this.props.data.site.siteMetadata.title
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: 'text-primary mb-3' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.heading.firstLine' }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.heading.secondLine' })
	      ),
	      _react2.default.createElement('div', {
	        className: 'mb-3 text-bold',
	        dangerouslySetInnerHTML: {
	          __html: sottotitolo.replace(/\n\n/g, '<br />')
	        }
	      }),
	      _react2.default.createElement('h2', {
	        className: 'Progetto__Abstract text-primary',
	        dangerouslySetInnerHTML: { __html: testoInEvidenza }
	      }),
	      _react2.default.createElement('div', {
	        className: 'text-size-1-2',
	        dangerouslySetInnerHTML: { __html: testo }
	      })
	    );
	  };
	
	  return ProgettoPage;
	}(_react.Component);
	
	exports.default = ProgettoPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-progetto-js-3b0b5fa91a42c7e00673.js